import React from 'react';
import PropTypes from 'prop-types';

import {InputAdornment, Collapse, IconButton} from 'views/components';
import {Edit} from 'views/icons';

const EditInputAdornment = (props) => {
  const {in: inProp, onClick} = props;
  return (
    <InputAdornment position='end'>
      <Collapse in={inProp} orientation='horizontal'>
        <IconButton onClick={onClick}>
          <Edit fontSize='small' />
        </IconButton>
      </Collapse>
    </InputAdornment>
  );
};

EditInputAdornment.propTypes = {
  in: PropTypes.bool,
  onClick: PropTypes.func,
};

export default EditInputAdornment;
